import apiService from './api-service';

const Roles = {};
const urlEntity = "/roles";

Roles.getOne = (id) => {
    return apiService.get(`${urlEntity}/${id}`)
        .then((res) => res);
};

Roles.selectAll = () => {
    return apiService.get(`${urlEntity}/select-all`)
        .then((res) => res);
};

Roles.selectAllAdmin = () => {
    return apiService.get(`${urlEntity}/select-all-admin`)
        .then((res) => res);
};


Roles.dataAll = () => {
    return apiService.get(`${urlEntity}/data-all`)
        .then((res) => res);
};

export default Roles;
